var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"title-poster__free-tag",class:_setup.label.length > 8 ? 'fz-13' : 'fz-14',on:{"click":_setup.setBuyBoxTypeToFree}},[_vm._v(" "+_vm._s(_setup.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }